import React from "react";

import { Link } from "react-router-dom";

import { Tag } from "antd";

import { LAYOUT_MANAGER_PROJECT_SHOW } from "../../navigation";

import { basicDeleteActionField } from "../../../../components/table/fields/common";

import { configureField } from "../../../../core/utils/list";

export const basicColumns = (props) => {
    const { toggle, loading, filters, resize, hidden } = props;

    if (loading) {
        return [];
    }

    return [
        {
            title: "Code",
            dataIndex: "code",
            key: "code",
            fixed: "left",
            render: (name, record) => <Link to={LAYOUT_MANAGER_PROJECT_SHOW(record.id)}>{name}</Link>,
            ...configureField("p.code", filters, resize, hidden, true, false, false, 200),
        },
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            ellipsis: true,
            ...configureField("p.name", filters, resize, hidden, true, false, true, 200),
        },
        {
            title: "Client",
            dataIndex: "client_fk",
            key: "client",
            sorter: true,
            render: (client) => {
                return <>{client?.name}</>;
            },
            ...configureField("c.name", filters, resize, hidden, true, false, true, 200),
        },
        {
            title: "Status",
            dataIndex: "active",
            key: "active",
            render: (check) => (
                <>{check ? <Tag color="green"> ENABLED </Tag> : <Tag color="volcano"> DISABLED </Tag>}</>
            ),
            ...configureField("p.active", filters, resize, hidden, true, false, true, 200),
        },
        {
            ...basicDeleteActionField({ toggle: props.toggle, remove: props.remove, loading: props.actionLoading }),
            visible: true,
        },
    ];
};
